import { render, staticRenderFns } from "./merge.vue?vue&type=template&id=620290fd"
import script from "./merge.vue?vue&type=script&lang=js"
export * from "./merge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports